import { IFIReportTypeItem, notEqual } from 'shared'
import { simpleEditNotification } from '../../../../../../../../../hooks/notificationHandler'

export const momentNotEqual = (
  a?: moment.Moment | null,
  b?: moment.Moment | null
) => notEqual(a, b, { transform: (value) => value.format('YYYY-MM-DD') })

export const ifiSettingsEditNotification = (
  reportType: IFIReportTypeItem['type']
) => simpleEditNotification(`${reportType} IFI Settings`)
